// extracted by mini-css-extract-plugin
export var statItem = "_id-1";
export var statsRow = "_id-0";